/* ============================================
   Hualle Outdoor - Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // === Header scroll effect ===
  var header = document.getElementById('main-header');
  var topbar = document.getElementById('topbar');
  var topbarSticky = topbar && topbar.classList.contains('topbar-sticky');

  // Position header below topbar + compensate body padding if topbar is fixed
  function adjustLayout() {
    var topbarH = topbar ? topbar.offsetHeight : 0;
    if (header) {
      header.style.top = topbarH + 'px';
    }
    if (topbarSticky) {
      document.body.style.paddingTop = topbarH + 'px';
    } else {
      document.body.style.paddingTop = '0px';
    }
  }
  adjustLayout();
  window.addEventListener('resize', adjustLayout);

  if (header) {
    window.addEventListener('scroll', function() {
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      var topbarH = topbar ? topbar.offsetHeight : 0;

      if (scroll > 0) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      // Non-sticky topbar: when scrolled past topbar, move header to top: 0
      if (topbar && !topbarSticky) {
        if (scroll > topbarH) {
          header.style.top = '0px';
        } else {
          header.style.top = topbarH + 'px';
        }
      }
    });
  }

  // === Search Modal ===
  function initSearchModal() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;

    var overlay = document.getElementById('search-overlay');
    var closeBtn = document.getElementById('search-close');
    var clearBtn = document.getElementById('search-clear');
    var input = document.getElementById('search-modal-input');
    var body = document.getElementById('search-modal-body');
    var content = document.getElementById('search-results-content');
    var suggestions = document.getElementById('search-suggestions');
    var filters = document.getElementById('search-filters');

    var activeFilter = 'product';
    var debounceTimer = null;
    var predictiveUrl = window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest.json';

    function open() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { if (input) input.focus(); }, 100);
    }
    function close() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      if (input) input.value = '';
      if (suggestions) suggestions.style.display = '';
      renderEmpty();
    }
    function renderEmpty() {
      if (suggestions) {
        suggestions.style.display = '';
        content.innerHTML = '';
        content.appendChild(suggestions);
      }
    }

    // Use event delegation for trigger click (works even if trigger is added later)
    document.addEventListener('click', function(e) {
      if (e.target.closest('#search-trigger')) {
        e.preventDefault();
        open();
      }
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) close();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (input) { input.value = ''; input.focus(); renderEmpty(); }
      });
    }

    // Filter chips
    if (filters) {
      filters.addEventListener('click', function(e) {
        var chip = e.target.closest('.search-filter-chip');
        if (!chip) return;
        filters.querySelectorAll('.search-filter-chip').forEach(function(c) { c.classList.remove('active'); });
        chip.classList.add('active');
        activeFilter = chip.getAttribute('data-filter');
        if (input && input.value.trim().length >= 2) performSearch(input.value);
      });
    }

    // Trending chips - use event delegation on modal
    modal.addEventListener('click', function(e) {
      var trend = e.target.closest('.search-trending-chip');
      if (!trend) return;
      var q = trend.getAttribute('data-query');
      if (input) { input.value = q; input.focus(); performSearch(q); }
    });

    // Debounced input
    if (input) {
      input.addEventListener('input', function() {
        var q = input.value.trim();
        if (debounceTimer) clearTimeout(debounceTimer);
        if (q.length < 2) { renderEmpty(); return; }
        debounceTimer = setTimeout(function() { performSearch(q); }, 300);
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = input.value.trim();
          if (q.length > 0) {
            window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=' + (activeFilter === 'collection' ? 'collection' : 'product');
          }
        }
      });
    }

    function performSearch(query) {
      if (suggestions) suggestions.style.display = 'none';
      var skeletonHtml = '<div class="search-skeleton-grid">';
      for (var i = 0; i < 6; i++) {
        skeletonHtml += '<div class="search-skeleton-card">' +
          '<div class="search-skeleton-img"></div>' +
          '<div class="search-skeleton-body">' +
          '<div class="search-skeleton-line"></div>' +
          '<div class="search-skeleton-line short"></div>' +
          '</div></div>';
      }
      skeletonHtml += '</div>';
      content.innerHTML = skeletonHtml;

      var resources = activeFilter === 'collection' ? 'collection' : 'product';
      var url = predictiveUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=' + resources + '&resources[limit]=9';

      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function(r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function(data) { renderResults(data, query); })
        .catch(function(err) {
          console.error('Search error:', err.message);
          content.innerHTML = '<div class="search-results-empty"><span class="material-symbols-outlined">cloud_off</span><p>Error al buscar. Intenta nuevamente.</p></div>';
        });
    }

    function renderResults(data, query) {
      var results = [];
      if (data && data.resources && data.resources.results) {
        var r = data.resources.results;
        if (activeFilter === 'collection') {
          results = r.collections || [];
        } else {
          results = r.products || [];
        }
      }
      if (results.length === 0) {
        content.innerHTML = '<div class="search-results-empty">' +
          '<span class="material-symbols-outlined">search_off</span>' +
          '<p>No encontramos resultados para "' + escapeHtml(query) + '". Prueba con otra palabra.</p>' +
          '<div class="search-trending">' +
          '<button class="search-trending-chip" data-query="pesca">Pesca</button>' +
          '<button class="search-trending-chip" data-query="mosca">Mosca</button>' +
          '<button class="search-trending-chip" data-query="camping">Camping</button>' +
          '<button class="search-trending-chip" data-query="outdoor">Outdoor</button>' +
          '</div></div>';
        return;
      }

      if (activeFilter === 'collection') {
        var collHtml = '<div class="search-results-list" style="display:flex;flex-direction:column;gap:var(--space-sm);">';
        results.forEach(function(item, i) {
          collHtml += '<a href="' + item.url + '" class="search-result-collection" style="animation-delay:' + (i * 60) + 'ms;">' +
            '<span class="material-symbols-outlined">folder</span>' +
            '<div class="search-result-collection-title">' + escapeHtml(item.title) + '</div>' +
            '<span class="search-result-card-type">Colección</span>' +
            '</a>';
        });
        collHtml += '</div>';
        collHtml += '<a href="/search?q=' + encodeURIComponent(query) + '&type=collection" class="search-view-all">Ver todas las colecciones <span class="material-symbols-outlined">arrow_forward</span></a>';
        content.innerHTML = collHtml;
      } else {
        var html = '<div class="search-results-grid">';
        results.forEach(function(item, i) {
          var img = '';
          if (item.image && typeof item.image === 'object' && item.image.url) {
            img = item.image.url;
          } else if (item.image && typeof item.image === 'string') {
            img = item.image;
          } else if (item.featured_image) {
            img = typeof item.featured_image === 'object' ? (item.featured_image.url || '') : item.featured_image;
          }
          var imgHtml = img ? '<img src="' + img + '" alt="" class="search-result-card-img" loading="lazy">' :
            '<div class="search-result-card-placeholder"><span class="material-symbols-outlined">image</span></div>';
          var price = '';
          if (item.price) {
            price = formatPrice(item.price);
          } else if (item.price_min) {
            price = formatPrice(item.price_min);
          }
          html += '<a href="' + item.url + '" class="search-result-card" style="animation-delay:' + (i * 60) + 'ms;">' +
            imgHtml +
            '<div class="search-result-card-body">' +
            '<div class="search-result-card-title">' + escapeHtml(item.title) + '</div>' +
            (price ? '<div class="search-result-card-price">' + price + '</div>' : '') +
            '</div></a>';
        });
        html += '</div>';
        html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="search-view-all">Ver todos los resultados <span class="material-symbols-outlined">arrow_forward</span></a>';
        content.innerHTML = html;
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function formatPrice(cents) {
      if (!cents) return '';
      var num = typeof cents === 'string' ? parseFloat(cents) : cents;
      if (num >= 100) num = num / 100;
      return '$' + num.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
  }
  initSearchModal();

  // === Topbar rotation ===
  function initTopbar() {
    var topbar = document.getElementById('topbar');
    if (!topbar) return;
    var messages = topbar.querySelectorAll('.topbar-message');
    if (messages.length <= 1) return;
    var speed = 4000;
    var speedAttr = topbar.getAttribute('data-speed');
    if (speedAttr) speed = parseInt(speedAttr, 10) * 1000;
    var current = 0;

    function rotate() {
      var active = messages[current];
      active.classList.remove('active');
      active.classList.add('exit');
      var next = (current + 1) % messages.length;
      messages[next].classList.add('enter');
      setTimeout(function() {
        active.classList.remove('exit');
        messages[next].classList.remove('enter');
        messages[next].classList.add('active');
        current = next;
      }, 600);
    }
    setInterval(rotate, speed);
  }
  initTopbar();

  // === Benefits Carousel (mobile) ===
  function initBenefitsCarousel() {
    var viewport = document.getElementById('benefits-carousel-viewport');
    var track = document.getElementById('benefits-carousel-track');
    if (!viewport || !track) return;
    var slides = track.querySelectorAll('.benefit-carousel-slide');
    if (slides.length <= 1) return;
    var current = 0;
    var total = slides.length;
    var timer = null;

    function isMobile() { return window.innerWidth < 768; }

    function goTo(idx) {
      current = idx;
      if (current < 0) current = total - 1;
      if (current >= total) current = 0;
      var slideW = slides[0].offsetWidth;
      track.style.transform = 'translateX(-' + (current * slideW) + 'px)';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAuto() {
      if (!isMobile()) return;
      stopAuto();
      timer = setInterval(next, 4000);
    }
    function stopAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Touch swipe
    var touchStartX = 0;
    var touchActive = false;
    viewport.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchActive = true;
      stopAuto();
    }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      if (!touchActive) return;
      touchActive = false;
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) next(); else prev();
      }
      startAuto();
    }, { passive: true });

    // Resize handler
    window.addEventListener('resize', function() {
      if (isMobile()) {
        goTo(current);
        startAuto();
      } else {
        stopAuto();
        track.style.transform = '';
      }
    });

    startAuto();
  }
  initBenefitsCarousel();

  // === Testimonials Carousel (mobile) ===
  function initTestimonialsCarousel() {
    var viewport = document.getElementById('testimonials-viewport');
    var track = document.getElementById('testimonials-track');
    if (!viewport || !track) return;
    var slides = track.querySelectorAll('.testimonial-card');
    if (slides.length <= 1) return;
    var current = 0;
    var total = slides.length;
    var prevBtn = document.getElementById('testimonials-prev');
    var nextBtn = document.getElementById('testimonials-next');
    var counter = document.getElementById('testimonials-current');

    function isMobile() { return window.innerWidth < 768; }

    function setSlideWidths() {
      var slideW = viewport.offsetWidth;
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = slideW + 'px';
        slides[i].style.minWidth = slideW + 'px';
      }
    }

    function updateUI() {
      if (counter) counter.textContent = current + 1;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    function goTo(idx) {
      current = idx;
      if (current < 0) current = 0;
      if (current >= total) current = total - 1;
      setSlideWidths();
      var slideW = viewport.offsetWidth;
      track.style.transform = 'translateX(-' + (current * slideW) + 'px)';
      updateUI();
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var touchStartX = 0;
    var touchActive = false;
    viewport.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      touchStartX = e.changedTouches[0].screenX;
      touchActive = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      if (!touchActive || !isMobile()) return;
      touchActive = false;
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) goTo(current + 1); else goTo(current - 1);
      }
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (isMobile()) {
        goTo(current);
      } else {
        track.style.transform = '';
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
          slides[i].style.minWidth = '';
        }
      }
    });

    if (isMobile()) setSlideWidths();
    updateUI();
  }
  initTestimonialsCarousel();

  // === Blog Preview Carousel (mobile) ===
  function initBlogCarousel() {
    var viewport = document.getElementById('blog-preview-viewport');
    var track = document.getElementById('blog-preview-track');
    if (!viewport || !track) return;
    var slides = track.querySelectorAll('.blog-card');
    if (slides.length <= 1) return;
    var current = 0;
    var total = slides.length;
    var prevBtn = document.getElementById('blog-preview-prev');
    var nextBtn = document.getElementById('blog-preview-next');
    var counter = document.getElementById('blog-preview-current');

    function isMobile() { return window.innerWidth < 768; }

    function setSlideWidths() {
      var slideW = viewport.offsetWidth;
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = slideW + 'px';
        slides[i].style.minWidth = slideW + 'px';
      }
    }

    function updateUI() {
      if (counter) counter.textContent = current + 1;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === total - 1;
    }

    function goTo(idx) {
      current = idx;
      if (current < 0) current = 0;
      if (current >= total) current = total - 1;
      setSlideWidths();
      var slideW = viewport.offsetWidth;
      track.style.transform = 'translateX(-' + (current * slideW) + 'px)';
      updateUI();
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    var touchStartX = 0;
    var touchActive = false;
    viewport.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      touchStartX = e.changedTouches[0].screenX;
      touchActive = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function(e) {
      if (!touchActive || !isMobile()) return;
      touchActive = false;
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) goTo(current + 1); else goTo(current - 1);
      }
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (isMobile()) {
        goTo(current);
      } else {
        track.style.transform = '';
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
          slides[i].style.minWidth = '';
        }
      }
    });

    if (isMobile()) setSlideWidths();
    updateUI();
  }
  initBlogCarousel();

  // === Cart Drawer ===
  function initCartDrawer() {
    var trigger = document.getElementById('cart-trigger');
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    var emptyState = document.getElementById('cart-drawer-empty');
    var itemsContainer = document.getElementById('cart-drawer-items');
    var footer = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    if (!drawer) return;

    var freeShippingThreshold = 0;
    if (footer) {
      var thresholdAttr = footer.getAttribute('data-threshold');
      if (thresholdAttr) freeShippingThreshold = parseInt(thresholdAttr, 10) || 50000;
    }

    function open() {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      renderCart();
    }
    function close() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (trigger) trigger.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });

    function formatMoney(cents) {
      var num = typeof cents === 'string' ? parseFloat(cents) : cents;
      if (num >= 100) num = num / 100;
      return '$' + num.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function renderCart() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEl = document.getElementById('cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? '' : 'none';
          }

          if (cart.item_count === 0) {
            if (emptyState) emptyState.style.display = '';
            if (itemsContainer) itemsContainer.innerHTML = '';
            if (footer) footer.style.display = 'none';
            return;
          }

          if (emptyState) emptyState.style.display = 'none';
          if (footer) footer.style.display = '';

          var html = '';
          cart.items.forEach(function(item) {
            var img = item.image ? item.image : '';
            var imgHtml = img ? '<img src="' + img + '&width=144" alt="' + escapeHtml(item.title) + '">' : '';
            var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-drawer-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
            html += '<div class="cart-drawer-item" data-key="' + item.key + '">' +
              '<div class="cart-drawer-item-image">' + imgHtml + '</div>' +
              '<div class="cart-drawer-item-info">' +
                '<div class="cart-drawer-item-title">' + escapeHtml(item.product_title) + '</div>' +
                variantHtml +
                '<div class="cart-drawer-item-bottom">' +
                  '<div class="cart-drawer-qty">' +
                    '<button class="cart-drawer-qty-btn" data-action="decrease" data-key="' + item.key + '"><span class="material-symbols-outlined">remove</span></button>' +
                    '<input class="cart-drawer-qty-input" value="' + item.quantity + '" data-key="' + item.key + '" readonly>' +
                    '<button class="cart-drawer-qty-btn" data-action="increase" data-key="' + item.key + '"><span class="material-symbols-outlined">add</span></button>' +
                  '</div>' +
                  '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>' +
              '</div>' +
              '<button class="cart-drawer-item-remove" data-key="' + item.key + '"><span class="material-symbols-outlined">delete</span></button>' +
            '</div>';
          });
          if (itemsContainer) itemsContainer.innerHTML = html;

          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

          if (itemsContainer) {
            itemsContainer.querySelectorAll('.cart-drawer-qty-btn').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var key = btn.getAttribute('data-key');
                var action = btn.getAttribute('data-action');
                var input = btn.parentElement.querySelector('.cart-drawer-qty-input');
                var qty = parseInt(input.value, 10) || 1;
                if (action === 'increase') qty++;
                else qty = Math.max(0, qty - 1);
                updateItem(key, qty);
              });
            });
            itemsContainer.querySelectorAll('.cart-drawer-item-remove').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var key = btn.getAttribute('data-key');
                updateItem(key, 0);
              });
            });
          }
        })
        .catch(function(err) { console.error('Cart render error:', err); });
    }

    function updateItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function() { renderCart(); })
      .catch(function(err) { console.error('Cart update error:', err); });
    }

    window.openCartDrawer = open;
  }
  initCartDrawer();

  // === Mobile menu ===
  var menuBtn = document.getElementById('mobile-menu-btn');
  var mobileMenu = document.getElementById('mobile-menu');
  var menuClose = document.getElementById('mobile-menu-close');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() { mobileMenu.classList.add('open'); });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function() { mobileMenu.classList.remove('open'); });
  }

  // === Hero carousel ===
  var heroSection = document.getElementById('hero-carousel');
  if (heroSection) {
    var slides = heroSection.querySelectorAll('.hero-slide-data');
    var bgActive = document.getElementById('bg-active');
    var bgNext = document.getElementById('bg-next');
    var title = document.getElementById('slide-title');
    var desc = document.getElementById('slide-desc');
    var btns = document.getElementById('slide-btn-group');
    var cardsTrack = document.getElementById('cards-wrapper');
    var cardsClip = document.getElementById('cards-clip');
    var cardsViewport = document.getElementById('cards-viewport');
    var currentSlide = 0;
    var autoPlayInterval;
    var originalCount = 0;
    var positionIndex = 0;
    var unit = 0;

    // Build an infinite marquee: clone the original cards before and after
    // themselves so sliding forward or backward never runs out of cards.
    function initCardsMarquee() {
      if (!cardsTrack) return;
      var originals = Array.prototype.slice.call(cardsTrack.querySelectorAll('.hero-card'));
      originalCount = originals.length;
      if (!originalCount) return;

      var beforeClones = originals.map(function(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        return clone;
      });
      var afterClones = originals.map(function(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        return clone;
      });

      cardsTrack.innerHTML = '';
      beforeClones.forEach(function(clone) { cardsTrack.appendChild(clone); });
      originals.forEach(function(card) { cardsTrack.appendChild(card); });
      afterClones.forEach(function(clone) { cardsTrack.appendChild(clone); });

      positionIndex = originalCount; // start at the first original card
    }

    function getAllCards() {
      return Array.prototype.slice.call(cardsTrack.querySelectorAll('.hero-card'));
    }

    function computeLayout() {
      if (!cardsTrack || !cardsViewport || !originalCount) return;
      var children = cardsTrack.children;
      if (children.length < 2) return;

      // Mobile: cards have variable width, just ensure clip is wide enough
      var isMobile = window.innerWidth < 768;
      if (isMobile) {
        var r0m = children[0].getBoundingClientRect();
        var r1m = children[1] ? children[1].getBoundingClientRect() : r0m;
        unit = r0m.width + (r1m.left - r0m.right);
        var csMobile = getComputedStyle(cardsViewport);
        var contentWidthMobile = cardsViewport.clientWidth
          - (parseFloat(csMobile.paddingLeft) || 0)
          - (parseFloat(csMobile.paddingRight) || 0);
        if (cardsClip) cardsClip.style.width = contentWidthMobile + 'px';
        return;
      }

      // Measure the real rendered card width and gap from DOM positions.
      var r0 = children[0].getBoundingClientRect();
      var r1 = children[1].getBoundingClientRect();
      var cardWidth = r0.width;
      var gapValue = r1.left - r0.right;
      unit = cardWidth + gapValue;

      // Measure the actual content width inside the wrapper's padding
      var cs = getComputedStyle(cardsViewport);
      var contentWidth = cardsViewport.clientWidth
        - (parseFloat(cs.paddingLeft) || 0)
        - (parseFloat(cs.paddingRight) || 0);

      // Floor with a 1px safety buffer to prevent sub-pixel overflow
      var visibleCount = unit > 0 ? Math.max(1, Math.floor((contentWidth + gapValue - 1) / unit)) : originalCount;
      visibleCount = Math.min(visibleCount, originalCount);

      if (cardsClip) {
        cardsClip.style.width = Math.round(visibleCount * unit - gapValue) + 'px';
      }
    }

    function applyPosition(animate) {
      if (!cardsTrack) return;
      var activeEl = cardsTrack.children[positionIndex];
      if (!activeEl) return;
      // Use offsetLeft for the transform (integer, no sub-pixel jitter)
      var offset = activeEl.offsetLeft;
      cardsTrack.style.transition = animate ? 'transform 700ms cubic-bezier(0.65, 0, 0.35, 1)' : 'none';
      cardsTrack.style.transform = 'translateX(-' + offset + 'px)';
    }

    function snapIfNeeded() {
      // Keep positionIndex within [originalCount, 2*originalCount) so there
      // is always a full buffer of clones on both sides to slide into.
      if (positionIndex >= originalCount * 2) {
        positionIndex -= originalCount;
        applyPosition(false);
      } else if (positionIndex < originalCount) {
        positionIndex += originalCount;
        applyPosition(false);
      }
    }

    function slideCardsTrack(direction) {
      if (!cardsTrack || !unit) return;
      positionIndex += direction;
      applyPosition(true);

      cardsTrack.addEventListener('transitionend', function handler() {
        cardsTrack.removeEventListener('transitionend', handler);
        snapIfNeeded();
      }, { once: true });
    }

    function refreshActiveClass() {
      getAllCards().forEach(function(card) {
        var idx = parseInt(card.getAttribute('data-slide'), 10);
        if (idx === currentSlide) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });
    }

    function updateUI() {
      var data = window.slideData[currentSlide];
      if (!data) return;

      // Build overlay gradient from slide's overlay setting (0-90)
      var overlay = typeof data.overlay === 'number' ? data.overlay : 50;
      var o = overlay / 100;
      var oTop = o.toFixed(2);
      var oMid = (o * 0.3).toFixed(2);
      var oBot = (o * 0.7).toFixed(2);
      var gradient = 'linear-gradient(rgba(0,0,0,' + oTop + ') 0%, rgba(0,0,0,' + oMid + ') 40%, rgba(0,0,0,' + oBot + ') 100%)';

      // Background transition: disable transitions during reset, then re-enable
      if (bgNext && bgActive) {
        // 1. Disable transitions to reset instantly
        bgActive.style.transition = 'none';
        bgNext.style.transition = 'none';

        // 2. Reset all state classes and inline styles
        bgActive.classList.remove('is-leaving');
        bgNext.classList.remove('is-entering');
        bgActive.style.opacity = '';
        bgNext.style.opacity = '';
        bgActive.style.transform = '';
        bgNext.style.transform = '';
        bgActive.style.filter = '';
        bgNext.style.filter = '';
        bgActive.style.clipPath = '';
        bgNext.style.clipPath = '';

        // 3. Set new image on next layer
        bgNext.style.backgroundImage = gradient + ", url('" + data.image + "')";

        // 4. Force reflow so reset takes effect
        void bgNext.offsetWidth;

        // 5. Re-enable CSS transitions
        bgActive.style.transition = '';
        bgNext.style.transition = '';

        // 6. Force another reflow so transitions are active
        void bgNext.offsetWidth;

        // 7. Trigger transition by adding state classes
        bgActive.classList.add('is-leaving');
        bgNext.classList.add('is-entering');

        // 8. After transition completes, sync active layer without animation
        setTimeout(function() {
          bgActive.style.transition = 'none';
          bgNext.style.transition = 'none';

          bgActive.style.backgroundImage = gradient + ", url('" + data.image + "')";
          bgActive.classList.remove('is-leaving');
          bgNext.classList.remove('is-entering');
          bgActive.style.opacity = '';
          bgNext.style.opacity = '';
          bgActive.style.transform = '';
          bgNext.style.transform = '';
          bgActive.style.filter = '';
          bgNext.style.filter = '';
          bgActive.style.clipPath = '';
          bgNext.style.clipPath = '';

          void bgActive.offsetWidth;

          bgActive.style.transition = '';
          bgNext.style.transition = '';
        }, 1400);
      }

      // Text transition: reset all elements first, then stagger
      var textElements = [title, desc, btns];
      textElements.forEach(function(el) {
        if (!el) return;
        el.classList.remove('slide-text-enter');
        el.style.animation = 'none';
      });

      // Force reflow to reset animations
      void heroSection.offsetWidth;

      // Re-add animation class with stagger
      textElements.forEach(function(el, i) {
        if (!el) return;
        el.style.animation = '';
        el.classList.add('slide-text-enter');
      });

      if (title) title.textContent = data.title;
      if (desc) desc.textContent = data.desc;

      if (btns) {
        var btnLink = btns.querySelector('a');
        if (data.btn1Text && data.btn1Text.trim() !== '') {
          if (btnLink) {
            btnLink.textContent = data.btn1Text;
            if (data.btn1Url && data.btn1Url.trim() !== '') {
              btnLink.setAttribute('href', data.btn1Url);
            }
            btnLink.style.display = '';
          } else {
            btns.innerHTML = '<a href="' + (data.btn1Url && data.btn1Url.trim() !== '' ? data.btn1Url : '/collections/all') + '" class="btn btn-primary">' + data.btn1Text + '</a>';
          }
        } else if (btnLink) {
          btnLink.style.display = 'none';
        }
      }

      refreshActiveClass();
    }

    function stepsBetween(from, to, total) {
      var diff = (to - from + total) % total;
      if (diff === 0) return 0;
      return diff <= total - diff ? diff : diff - total;
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % window.slideData.length;
      slideCardsTrack(1);
      updateUI();
      resetTimer();
    }

    function prevSlide() {
      currentSlide = (currentSlide - 1 + window.slideData.length) % window.slideData.length;
      slideCardsTrack(-1);
      updateUI();
      resetTimer();
    }

    function syncToSlide(index) {
      if (index === currentSlide) return;
      var steps = stepsBetween(currentSlide, index, window.slideData.length);
      currentSlide = index;
      slideCardsTrack(steps);
      updateUI();
      resetTimer();
    }

    function resetTimer() {
      clearInterval(autoPlayInterval);
      autoPlayInterval = setInterval(nextSlide, 5000);
    }

    // Expose functions
    window.nextSlide = nextSlide;
    window.prevSlide = prevSlide;
    window.syncToSlide = syncToSlide;

    // Card click handlers (delegated so clones also work)
    cardsTrack.addEventListener('click', function(e) {
      var card = e.target.closest('.hero-card');
      if (!card) return;
      var idx = parseInt(card.getAttribute('data-slide'), 10);
      if (!isNaN(idx)) syncToSlide(idx);
    });

    // Nav buttons
    var prevBtn = heroSection.querySelector('.hero-nav-prev');
    var nextBtn = heroSection.querySelector('.hero-nav-next');
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    // Build marquee clones, compute sizing, set initial position
    initCardsMarquee();
    computeLayout();
    applyPosition(false);
    refreshActiveClass();

    window.addEventListener('resize', function() {
      computeLayout();
      applyPosition(false);
    });

    // Start autoplay
    resetTimer();

    // Touch swipe support for mobile
    var touchStartX = 0;
    var touchEndX = 0;
    var touchActive = false;
    if (cardsViewport) {
      cardsViewport.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchActive = true;
      }, { passive: true });
      cardsViewport.addEventListener('touchend', function(e) {
        if (!touchActive) return;
        touchActive = false;
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) nextSlide();
          else prevSlide();
        }
      }, { passive: true });
    }
  }

  // === FAQ Accordion ===
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.addEventListener('click', function() {
      item.classList.toggle('open');
    });
  });

  // === PDP Tabs ===
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.getAttribute('data-tab');
      document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var content = document.getElementById(target);
      if (content) content.classList.add('active');
    });
  });

  // === PDP Image Gallery ===
  document.querySelectorAll('.pdp-thumbnail').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.querySelector('img').src;
      var main = document.getElementById('pdp-main-image');
      if (main) {
        main.style.opacity = '0';
        setTimeout(function() {
          main.src = src;
          main.style.opacity = '1';
        }, 200);
      }
      document.querySelectorAll('.pdp-thumbnail').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // === Cart quantity update ===
  document.querySelectorAll('.cart-quantity-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('.cart-quantity-input');
      var action = btn.getAttribute('data-action');
      var value = parseInt(input.value) || 1;
      if (action === 'increase') { value++; }
      else if (action === 'decrease') { value = Math.max(1, value - 1); }
      input.value = value;
      input.dispatchEvent(new Event('change'));
    });
  });

  // === Add to cart AJAX ===
  document.querySelectorAll('.add-to-cart-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var payload = {
        id: idInput ? idInput.value : null,
        quantity: qtyInput ? parseInt(qtyInput.value) || 1 : 1
      };
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (window.openCartDrawer) {
          window.openCartDrawer();
        } else {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.getElementById('cart-count');
              if (countEl) countEl.textContent = cart.item_count;
            });
        }
      })
      .catch(function(err) { console.error('Add to cart error:', err); });
    });
  });

  // === Quick View Modal ===
  function initQuickView() {
    var modal = document.getElementById('quickview-modal');
    var overlay = document.getElementById('quickview-overlay');
    var closeBtn = document.getElementById('quickview-close');
    var content = document.getElementById('quickview-content');
    if (!modal) return;

    var selectedVariantId = null;
    var selectedQty = 1;

    function open() {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      content.innerHTML = '<div class="quickview-loading"><span class="material-symbols-outlined">progress_activity</span></div>';
      selectedVariantId = null;
      selectedQty = 1;
    }

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) close();
    });

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, '${{amount}}');
      }
      return '$' + (cents / 100).toLocaleString('es-CL');
    }

    function stripHtml(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    }

    function renderProduct(product) {
      var image = product.featured_image ? product.featured_image.replace('.jpg', '_800x800.jpg').replace('.png', '_800x800.png') : '';
      if (!image && product.images && product.images.length > 0) image = product.images[0];
      var comparePrice = product.compare_at_price;
      var onSale = comparePrice && comparePrice > product.price;
      var available = product.available;
      var variants = product.variants || [];
      var hasMultipleVariants = variants.length > 1;

      var variantsHtml = '';
      var rawOptions = product.options || [];
      var options = rawOptions.map(function(o) { return typeof o === 'string' ? o : (o.name || o.title || String(o)); });
      if (hasMultipleVariants && options.length > 0) {
        if (options.length === 1) {
          // Single option: show option name as label, option values as chips
          var optionName = options[0];
          var optionValues = [];
          var seen = {};
          variants.forEach(function(v) {
            var val = v.option1;
            if (val && !seen[val]) { seen[val] = true; optionValues.push({ value: val, variant: v }); }
          });
          var chipsHtml = optionValues.map(function(item, i) {
            var isActive = i === 0 ? ' active' : '';
            var isDisabled = !item.variant.available ? ' disabled' : '';
            return '<button type="button" class="quickview-variant-chip' + isActive + isDisabled + '" data-variant-id="' + item.variant.id + '" data-variant-price="' + item.variant.price + '" data-variant-available="' + item.variant.available + '">' + item.value + '</button>';
          }).join('');
          variantsHtml = '<div class="quickview-variants">' +
            '<span class="quickview-variants-label">' + optionName + '</span>' +
            '<div class="quickview-variants-list">' + chipsHtml + '</div>' +
          '</div>';
        } else {
          // Multiple options: render each option as separate group
          variantsHtml = options.map(function(optName, optIdx) {
            var optionValues = [];
            var seen = {};
            variants.forEach(function(v) {
              var val = v['option' + (optIdx + 1)];
              if (val && !seen[val]) { seen[val] = true; optionValues.push(val); }
            });
            var chipsHtml = optionValues.map(function(val, i) {
              var isActive = i === 0 ? ' active' : '';
              return '<button type="button" class="quickview-variant-chip' + isActive + '" data-option-position="' + (optIdx + 1) + '" data-value="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
            }).join('');
            return '<div class="quickview-variants">' +
              '<span class="quickview-variants-label">' + optName + '</span>' +
              '<div class="quickview-variants-list">' + chipsHtml + '</div>' +
            '</div>';
          }).join('');
        }
      }

      var priceHtml = '<div class="quickview-price-row"><span class="quickview-price">' + formatMoney(product.price) + '</span>';
      if (onSale) priceHtml += '<span class="quickview-compare-price">' + formatMoney(comparePrice) + '</span>';
      priceHtml += '</div>';

      var desc = product.description ? stripHtml(product.description) : '';
      if (desc.length > 200) desc = desc.substring(0, 200) + '...';

      var actionsHtml;
      if (available) {
        actionsHtml = '<div class="quickview-actions">' +
          '<div class="quickview-qty-selector">' +
            '<button type="button" class="quickview-qty-btn" data-action="decrease"><span class="material-symbols-outlined">remove</span></button>' +
            '<input type="text" class="quickview-qty-input" value="1" readonly>' +
            '<button type="button" class="quickview-qty-btn" data-action="increase"><span class="material-symbols-outlined">add</span></button>' +
          '</div>' +
          '<button type="button" class="quickview-add-cart" id="quickview-add-cart-btn">' +
            '<span class="material-symbols-outlined">shopping_bag</span>' +
            '<span>Agregar al carrito</span>' +
          '</button>' +
        '</div>';
      } else {
        actionsHtml = '<div class="quickview-sold-out"><span class="material-symbols-outlined">block</span><span>Producto agotado</span></div>';
      }

      var badge = onSale ? '<div class="quickview-image-badge">Oferta</div>' : '';

      var html = '<div class="quickview-grid">' +
        '<div class="quickview-image-side">' +
          badge +
          (image ? '<img src="' + image + '" alt="' + product.title + '">' : '') +
        '</div>' +
        '<div class="quickview-info-side">' +
          (product.vendor ? '<span class="quickview-vendor">' + product.vendor + '</span>' : '') +
          '<h2 class="quickview-title">' + product.title + '</h2>' +
          priceHtml +
          '<div class="quickview-divider"></div>' +
          (desc ? '<p class="quickview-description">' + desc + '</p>' : '') +
          (desc ? '<div class="quickview-divider"></div>' : '') +
          variantsHtml +
          actionsHtml +
          '<a href="' + product.url + '" class="quickview-view-full"><span class="material-symbols-outlined">open_in_new</span><span>Ver página completa</span></a>' +
        '</div>' +
      '</div>';

      content.innerHTML = html;

      selectedVariantId = variants.length > 0 ? variants[0].id : product.id;
      selectedQty = 1;

      // Check if single-option mode (chips have data-variant-id)
      var singleOptionChips = content.querySelectorAll('.quickview-variant-chip[data-variant-id]');
      if (singleOptionChips.length > 0) {
        singleOptionChips.forEach(function(chip) {
          chip.addEventListener('click', function() {
            singleOptionChips.forEach(function(c) { c.classList.remove('active'); });
            chip.classList.add('active');
            selectedVariantId = chip.getAttribute('data-variant-id');
            var variantPrice = chip.getAttribute('data-variant-price');
            var variantAvailable = chip.getAttribute('data-variant-available') === 'true';
            var priceEl = content.querySelector('.quickview-price');
            if (priceEl && variantPrice) priceEl.textContent = formatMoney(parseInt(variantPrice));
            var addBtn = document.getElementById('quickview-add-cart-btn');
            if (addBtn) addBtn.disabled = !variantAvailable;
          });
        });
      } else {
        // Multiple options: chips have data-option-position and data-value
        var multiChips = content.querySelectorAll('.quickview-variant-chip[data-option-position]');
        multiChips.forEach(function(chip) {
          chip.addEventListener('click', function() {
            var pos = chip.getAttribute('data-option-position');
            // Deactivate other chips in same option group
            content.querySelectorAll('.quickview-variant-chip[data-option-position="' + pos + '"]').forEach(function(c) { c.classList.remove('active'); });
            chip.classList.add('active');
            // Find matching variant
            var selected = {};
            content.querySelectorAll('.quickview-variant-chip.active').forEach(function(c) {
              var p = c.getAttribute('data-option-position');
              selected['option' + p] = c.getAttribute('data-value');
            });
            var match = variants.find(function(v) {
              return v.option1 === selected.option1 && v.option2 === selected.option2 && v.option3 === selected.option3;
            });
            if (match) {
              selectedVariantId = match.id;
              var priceEl = content.querySelector('.quickview-price');
              if (priceEl) priceEl.textContent = formatMoney(match.price);
              var addBtn = document.getElementById('quickview-add-cart-btn');
              if (addBtn) addBtn.disabled = !match.available;
            }
          });
        });
      }

      var qtyBtns = content.querySelectorAll('.quickview-qty-btn');
      var qtyInput = content.querySelector('.quickview-qty-input');
      qtyBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var action = btn.getAttribute('data-action');
          if (action === 'increase') selectedQty++;
          else selectedQty = Math.max(1, selectedQty - 1);
          if (qtyInput) qtyInput.value = selectedQty;
        });
      });

      var addCartBtn = document.getElementById('quickview-add-cart-btn');
      if (addCartBtn) {
        addCartBtn.addEventListener('click', function() {
          addCartBtn.disabled = true;
          addCartBtn.innerHTML = '<span class="material-symbols-outlined">progress_activity</span><span>Agregando...</span>';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: selectedQty })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            addCartBtn.innerHTML = '<span class="material-symbols-outlined">check</span><span>Agregado</span>';
            setTimeout(function() {
              close();
              if (window.openCartDrawer) window.openCartDrawer();
            }, 800);
          })
          .catch(function(err) {
            console.error('Quick view add to cart error:', err);
            addCartBtn.disabled = false;
            addCartBtn.innerHTML = '<span class="material-symbols-outlined">shopping_bag</span><span>Agregar al carrito</span>';
          });
        });
      }
    }

    function renderProductFromData(name, price, image, productUrl) {
      var btn = arguments[4] || {};
      var vendor = btn.vendor || '';
      var badge = btn.badge || '';
      var description = btn.description || '';
      var features = btn.features || '';
      var rating = parseFloat(btn.rating) || 0;
      var reviews = btn.reviews || 0;
      var url = productUrl || '/collections/all';

      var imgHtml = image ? '<img src="' + image + '" alt="' + name + '">' : '';
      var badgeHtml = badge ? '<div class="quickview-image-badge">' + badge + '</div>' : '';
      var vendorHtml = vendor ? '<span class="quickview-vendor">' + vendor + '</span>' : '';

      var starsHtml = '';
      if (rating > 0) {
        var fullStars = Math.floor(rating);
        var hasHalf = rating % 1 >= 0.5;
        for (var s = 0; s < 5; s++) {
          if (s < fullStars) starsHtml += '<span class="material-symbols-outlined">star</span>';
          else if (s === fullStars && hasHalf) starsHtml += '<span class="material-symbols-outlined">star_half</span>';
          else starsHtml += '<span class="material-symbols-outlined qv-star-empty">star</span>';
        }
      }

      var ratingHtml = '';
      if (rating > 0) {
        ratingHtml = '<div class="quickview-rating">' +
          '<div class="quickview-rating-stars">' + starsHtml + '</div>' +
          '<span class="quickview-rating-text">' + rating.toFixed(1) + ' (' + reviews + ' reseñas)</span>' +
        '</div>';
      }

      var featuresHtml = '';
      if (features && features.trim() !== '') {
        var featureList = features.split(',').map(function(f) { return f.trim(); }).filter(function(f) { return f.length > 0; });
        if (featureList.length > 0) {
          var chipsHtml = featureList.map(function(f) {
            return '<span class="quickview-feature-chip"><span class="material-symbols-outlined">check_circle</span>' + f + '</span>';
          }).join('');
          featuresHtml = '<div class="quickview-features">' + chipsHtml + '</div>';
        }
      }

      var priceHtml = '<div class="quickview-price-row"><span class="quickview-price">' + price + '</span></div>';

      var html = '<div class="quickview-grid">' +
        '<div class="quickview-image-side">' +
          badgeHtml +
          imgHtml +
          '<div class="quickview-image-gradient"></div>' +
          (vendor ? '<div class="quickview-image-meta"><span class="material-symbols-outlined">verified</span><span>' + vendor + '</span></div>' : '') +
        '</div>' +
        '<div class="quickview-info-side">' +
          vendorHtml +
          '<h2 class="quickview-title">' + name + '</h2>' +
          ratingHtml +
          priceHtml +
          '<div class="quickview-divider"></div>' +
          (description ? '<p class="quickview-description">' + description + '</p>' : '') +
          (description ? '<div class="quickview-divider"></div>' : '') +
          featuresHtml +
          (featuresHtml ? '<div class="quickview-divider"></div>' : '') +
          '<div class="quickview-actions">' +
            '<a href="' + url + '" class="quickview-add-cart" style="text-decoration:none;">' +
              '<span class="material-symbols-outlined">shopping_bag</span>' +
              '<span>Ir a comprar</span>' +
            '</a>' +
          '</div>' +
          '<a href="' + url + '" class="quickview-view-full"><span class="material-symbols-outlined">open_in_new</span><span>Ver página completa</span></a>' +
        '</div>' +
      '</div>';

      content.innerHTML = html;
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.explore-btn-preview');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');

      if (handle && handle.trim() !== '' && handle !== '/collections/all') {
        open();
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            renderProduct(product);
          })
          .catch(function(err) {
            console.error('Quick view fetch error:', err);
            content.innerHTML = '<div class="quickview-loading"><p>Error al cargar el producto</p></div>';
          });
      } else {
        var name = btn.getAttribute('data-product-name') || 'Producto';
        var price = btn.getAttribute('data-product-price') || '';
        var image = btn.getAttribute('data-product-image') || '';
        var productUrl = '';
        var card = btn.closest('.explore-product-card');
        var link = card ? card.querySelector('.explore-product-link') : null;
        if (link) productUrl = link.getAttribute('href');

        var dataObj = {
          vendor: btn.getAttribute('data-product-vendor') || '',
          badge: btn.getAttribute('data-product-badge') || '',
          description: btn.getAttribute('data-product-description') || '',
          features: btn.getAttribute('data-product-features') || '',
          rating: btn.getAttribute('data-product-rating') || '0',
          reviews: btn.getAttribute('data-product-reviews') || '0'
        };

        open();
        renderProductFromData(name, price, image, productUrl, dataObj);
      }
    });

    // Also handle PLP quick view buttons (unified modal)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card-quickview');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      open();
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          renderProduct(product);
        })
        .catch(function(err) {
          console.error('PLP quick view error:', err);
          content.innerHTML = '<div class="quickview-loading"><p>Error al cargar</p></div>';
        });
    });
  }
  initQuickView();

  // === PLP: Custom Dropdowns, Filters, Quick View ===

  // Custom dropdown toggle (generic)
  document.querySelectorAll('.custom-dropdown').forEach(function(dd) {
    var trigger = dd.querySelector('.custom-dropdown-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      // Close other dropdowns
      document.querySelectorAll('.custom-dropdown.open').forEach(function(other) {
        if (other !== dd) other.classList.remove('open');
      });
      dd.classList.toggle('open');
    });
  });
  // Close dropdowns on outside click
  document.addEventListener('click', function() {
    document.querySelectorAll('.custom-dropdown.open').forEach(function(dd) {
      dd.classList.remove('open');
    });
  });

  // Sort dropdown (desktop + mobile)
  function initSortDropdown(dropdownId, triggerLabelId, menuId) {
    var menu = document.getElementById(menuId);
    var label = document.getElementById(triggerLabelId);
    if (!menu || !label) return;
    menu.querySelectorAll('.custom-dropdown-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        var sortValue = opt.getAttribute('data-sort');
        label.textContent = opt.textContent;
        menu.querySelectorAll('.custom-dropdown-option').forEach(function(o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        var dd = document.getElementById(dropdownId);
        if (dd) dd.classList.remove('open');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });
    // Mark current sort
    var currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'manual';
    menu.querySelectorAll('.custom-dropdown-option').forEach(function(opt) {
      if (opt.getAttribute('data-sort') === currentSort) {
        opt.classList.add('selected');
        label.textContent = opt.textContent;
      }
    });
  }
  initSortDropdown('sort-dropdown', 'sort-trigger-label', 'sort-menu');

  // Brand dropdown + badges
  var selectedBrands = [];
  var brandMenu = document.getElementById('brand-menu');
  var brandTriggerLabel = document.getElementById('brand-trigger-label');
  var activeFiltersContainer = document.getElementById('plp-active-filters');

  function renderBrandBadges() {
    if (!activeFiltersContainer) return;
    activeFiltersContainer.innerHTML = '';
    selectedBrands.forEach(function(brand) {
      var badge = document.createElement('span');
      badge.className = 'plp-filter-badge';
      badge.innerHTML = '<span>' + brand.label + '</span><span class="material-symbols-outlined" data-vendor="' + brand.vendor + '">close</span>';
      badge.querySelector('.material-symbols-outlined').addEventListener('click', function() {
        removeBrand(brand.vendor);
      });
      activeFiltersContainer.appendChild(badge);
    });
  }

  function removeBrand(vendor) {
    selectedBrands = selectedBrands.filter(function(b) { return b.vendor !== vendor; });
    // Uncheck in dropdown
    if (brandMenu) {
      brandMenu.querySelectorAll('.custom-dropdown-option').forEach(function(opt) {
        if (opt.getAttribute('data-vendor') === vendor) opt.classList.remove('selected');
      });
    }
    if (brandTriggerLabel) brandTriggerLabel.textContent = selectedBrands.length > 0 ? selectedBrands.map(function(b) { return b.label; }).join(', ') : 'Seleccionar marca';
    renderBrandBadges();
    applyFilters();
  }

  function applyFilters() {
    var cards = document.querySelectorAll('.product-card');
    var priceRange = document.getElementById('price-range');
    var maxPrice = priceRange ? parseInt(priceRange.value, 10) : null;
    var priceMax = priceRange ? parseInt(priceRange.max, 10) : null;
    var isPriceFiltered = maxPrice !== null && maxPrice < priceMax;
    cards.forEach(function(card) {
      var show = true;
      // Brand filter
      if (selectedBrands.length > 0) {
        var cardVendor = '';
        var vendorEl = card.querySelector('.product-card-vendor');
        if (vendorEl) cardVendor = vendorEl.textContent.trim().handleize || vendorEl.textContent.trim().toLowerCase().replace(/\s+/g, '-');
        var match = selectedBrands.some(function(b) { return b.vendor === cardVendor; });
        if (!match) show = false;
      }
      // Price filter - only apply if slider is not at max
      if (isPriceFiltered && show) {
        var cardPrice = parseInt(card.getAttribute('data-price'), 10);
        if (isNaN(cardPrice)) {
          var priceEl = card.querySelector('.product-card-price');
          if (priceEl) {
            var priceText = priceEl.textContent.replace(/[^0-9]/g, '');
            cardPrice = parseInt(priceText, 10);
          }
        }
        if (!isNaN(cardPrice) && cardPrice > maxPrice) show = false;
      }
      card.style.display = show ? '' : 'none';
    });
  }

  if (brandMenu) {
    brandMenu.querySelectorAll('.custom-dropdown-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        var vendor = opt.getAttribute('data-vendor');
        var label = opt.querySelector('span').textContent;
        var isSelected = opt.classList.contains('selected');
        if (isSelected) {
          opt.classList.remove('selected');
          selectedBrands = selectedBrands.filter(function(b) { return b.vendor !== vendor; });
        } else {
          opt.classList.add('selected');
          selectedBrands.push({ vendor: vendor, label: label });
        }
        if (brandTriggerLabel) {
          brandTriggerLabel.textContent = selectedBrands.length > 0 ? selectedBrands.map(function(b) { return b.label; }).join(', ') : 'Seleccionar marca';
        }
        renderBrandBadges();
        applyFilters();
        var dd = document.getElementById('brand-dropdown');
        if (dd) dd.classList.remove('open');
      });
    });
  }

  // Price slider
  var priceRange = document.getElementById('price-range');
  var priceFill = document.getElementById('price-fill');
  var priceMaxLabel = document.getElementById('price-max-label');
  if (priceRange && priceFill && priceMaxLabel) {
    function updatePrice() {
      var val = parseInt(priceRange.value, 10);
      var min = parseInt(priceRange.min, 10);
      var max = parseInt(priceRange.max, 10);
      var pct = ((val - min) / (max - min)) * 100;
      priceFill.style.width = pct + '%';
      priceMaxLabel.textContent = '$' + val.toLocaleString('es-CL');
      applyFilters();
    }
    priceRange.addEventListener('input', updatePrice);
    updatePrice();
  }

  // Filter clear
  var filterClear = document.getElementById('filter-clear');
  if (filterClear) {
    filterClear.addEventListener('click', function() {
      selectedBrands = [];
      if (brandMenu) {
        brandMenu.querySelectorAll('.custom-dropdown-option').forEach(function(opt) { opt.classList.remove('selected'); });
      }
      if (brandTriggerLabel) brandTriggerLabel.textContent = 'Seleccionar marca';
      if (priceRange) { priceRange.value = priceRange.max; }
      if (priceFill) priceFill.style.width = '100%';
      if (priceMaxLabel) priceMaxLabel.textContent = '$' + parseInt(priceRange.max, 10).toLocaleString('es-CL');
      renderBrandBadges();
      applyFilters();
    });
  }

  // Mobile filter toggle
  var filterToggleBtn = document.getElementById('filter-toggle');
  var filterSidebar = document.getElementById('filter-sidebar');
  var filterOverlay = document.getElementById('filter-sidebar-overlay');
  var filterCloseMobile = document.getElementById('filter-close-mobile');

  function openMobileFilter() {
    if (filterSidebar) filterSidebar.classList.add('open');
    if (filterOverlay) filterOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileFilter() {
    if (filterSidebar) filterSidebar.classList.remove('open');
    if (filterOverlay) filterOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  if (filterToggleBtn) filterToggleBtn.addEventListener('click', openMobileFilter);
  if (filterOverlay) filterOverlay.addEventListener('click', closeMobileFilter);
  if (filterCloseMobile) filterCloseMobile.addEventListener('click', closeMobileFilter);

  // Category collapsible toggle
  document.querySelectorAll('.filter-cat-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var block = btn.closest('.filter-cat-block');
      if (block) block.classList.toggle('expanded');
    });
  });

});
